import React from 'react'
import { SxProps, Theme } from '@mui/material/styles'

import {
	LeaderboardSelectedIcon,
	LeaderboardDeselectedIcon,
	RecruitingSelectedIcon,
	RecruitingDeselectedIcon,
	AgentsIcon,
	SignoutIcon,
	SvgAddComment,
	SvgAddCommentFill,
} from '@/public/icons/menu_item'

export const enum NavIds {
	BusinessIntelligence,
	BI,
	Recruiting,
	AgentManagement,
	Feedback,
	Signout,
}

export default interface NavItem {
	iconSelected: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
	iconDeselected: React.FunctionComponent<React.SVGProps<SVGSVGElement>>
	label: string
	labelMini?: string
	url: string
	show?: boolean
	navId: NavIds
	wrapText?: boolean
}

export const navItems: NavItem[] = [
	{
		iconSelected: LeaderboardSelectedIcon,
		iconDeselected: LeaderboardDeselectedIcon,
		label: 'Business intelligence',
		labelMini: 'BI',
		url: '/feature/dashboard',
		navId: NavIds.BusinessIntelligence,
	},
	{
		iconSelected: RecruitingSelectedIcon,
		iconDeselected: RecruitingDeselectedIcon,
		label: 'Recruiting',
		labelMini: 'Recruiting',
		url: '/feature/recruiting/mlssearch',
		navId: NavIds.Recruiting,
	},
	{
		iconSelected: AgentsIcon,
		iconDeselected: AgentsIcon,
		label: 'Your agents',
		labelMini: 'Your agents',
		url: '/feature/agentmanagement',
		navId: NavIds.AgentManagement,
		wrapText: true,
	},
	{
		iconSelected: SvgAddCommentFill,
		iconDeselected: SvgAddComment,
		label: 'Feedback',
		labelMini: 'Feedback',
		url: '/feature/feedback',
		navId: NavIds.Feedback,
	},
	{
		iconSelected: SignoutIcon,
		iconDeselected: SignoutIcon,
		label: 'Log out',
		labelMini: 'Log out',
		url: '/auth/signout',
		navId: NavIds.Signout,
	},
]

export interface LeftNavProps {
	setOpen: React.Dispatch<React.SetStateAction<boolean>>
	changeFeaturePage: (navId: NavIds) => void
	isTncSelected: boolean
	setIsTncSelected: React.Dispatch<React.SetStateAction<boolean>>
	navItemSx: (selected: boolean) => object | SxProps<Theme>
}
